"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTextArea = void 0;
const react_1 = __importDefault(require("react"));
const FormField_1 = require("../base/FormField");
const FieldWrapper_1 = require("./FieldWrapper");
class FormTextArea extends FormField_1.FormField {
    render() {
        return (react_1.default.createElement(FieldWrapper_1.FormFieldWrapper, Object.assign({}, this.wrapperProps),
            react_1.default.createElement("textarea", { value: this.value, onChange: e => this.setValue(e.target.value), className: "form__text-area" })));
    }
}
exports.FormTextArea = FormTextArea;
//# sourceMappingURL=TextArea.js.map